<template>
  <v-container fluid>
    <h2>Définition du produit</h2>
    <p>
      <v-chip :color="demande.produitPublie ? 'success' : 'error'"
        >{{ demande.produitPublie ? "D" : "NON d" }}isponible dans la base
        Europharmat</v-chip
      >
    </p>
    <h3>1. Renseignements administratifs concernant l'entreprise</h3>
    <p>{{ fournisseur.nom }}</p>
    <p class="hint">
      Pour modifier les informations Fournisseur de la DM, utiliser la fonction
      Fiche Fournisseur.
    </p>
    <v-row>
      <v-col cols="12" md="3"
        ><h4 class="ml-3">Division / Business Unit</h4>
      </v-col>
      <v-col cols="12" md="9"
        ><v-text-field
          v-model="divisionFournisseur"
          counter="80"
          :disabled="readOnly"
          hide-details="auto"
          single-line
          dense
          filled
          hint="Divsion ou Business Unit"
          :error-messages="divisionFournisseurErrors"
          @input="$v.divisionFournisseur.$touch()"
          @blur="$v.divisionFournisseur.$touch()"
        ></v-text-field
      ></v-col>
    </v-row>

    <h3>2. Informations sur dispositif et équipement</h3>
    <v-row>
      <v-col cols="12" md="3"><h4>2.1 Dénomination commune</h4></v-col>
      <v-col cols="12" md="9"
        ><produit-info-autocomplete
          v-model="idDenoCommune"
          kind="denos"
          hide-details="no"
          :disabled="readOnly"
          :defaultValue="demande.denominationCommune"
          :errors="idDenoCommuneErrors"
          @input="denoCommuneInput"
          @blur="$v.idDenoCommune.$touch()"
        ></produit-info-autocomplete
      ></v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <h4>2.2 Dénomination commerciale</h4>
      </v-col>
      <v-col cols="12" md="9"
        ><v-text-field
          v-model="denominationCommerciale"
          counter="500"
          :disabled="readOnly"
          single-line
          hide-details="auto"
          filled
          dense
          :error-messages="denominationCommercialeErrors"
          @input="$v.denominationCommerciale.$touch()"
          @blur="$v.denominationCommerciale.$touch()"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <h4>2.3 Nomenclature GMDN</h4>
      </v-col>
      <v-col cols="12" md="9"
        ><v-text-field
          v-model="codeProduit"
          counter="50"
          :disabled="readOnly"
          hide-details="auto"
          single-line
          filled
          dense
          :error-messages="codeProduitErrors"
          @input="$v.codeProduit.$touch()"
          @blur="$v.codeProduit.$touch()"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <h4 class="ml-7">Code EMDN (ou Cladimed phase transitoire)</h4>
      </v-col>
      <v-col cols="12" md="9"
        ><v-text-field
          v-model="cladimedPro"
          counter="50"
          :disabled="readOnly"
          hide-details="auto"
          single-line
          filled
          dense
          :error-messages="cladimedProErrors"
          @input="$v.cladimedPro.$touch()"
          @blur="$v.cladimedPro.$touch()"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <h4>2.4 Code LPP</h4>
      </v-col>
      <v-col cols="12" md="9"
        ><v-text-field
          v-model="codeLpp"
          :disabled="readOnly"
          counter="80"
          hide-details="auto"
          single-line
          filled
          dense
          :error-messages="codeLppErrors"
          @input="$v.codeLpp.$touch()"
          @blur="$v.codeLpp.$touch()"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <h4>2.5 Classe DM</h4>
      </v-col>
      <v-col cols="12" md="9"
        ><v-text-field
          v-model="classeDm"
          counter="20"
          :disabled="readOnly"
          hide-details="auto"
          single-line
          filled
          dense
          :error-messages="classeDmErrors"
          @input="$v.classeDm.$touch()"
          @blur="$v.classeDm.$touch()"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card flat>
          <v-card-title style="font-size: 1em">
            <v-switch
              class="v-input--reverse mt-0 ml-3"
              inset
              v-model="marquageCeB"
              :disabled="readOnly"
            >
              <template v-slot:label> Marquage CE </template>
            </v-switch>
          </v-card-title>
          <v-card-text>
            <v-expand-transition>
              <v-container v-show="marquageCeB">
                <v-row>
                  <v-col cols="12" md="3"> Disposition réglementaire </v-col>
                  <v-col cols="12" md="9">
                    <v-text-field
                      v-model="marquageCe"
                      counter="120"
                      :disabled="readOnly"
                      hide-details="auto"
                      single-line
                      filled
                      dense
                      :error-messages="marquageCeErrors"
                      @input="$v.marquageCe.$touch()"
                      @blur="$v.marquageCe.$touch()"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">Numéro de l'organisme notifié</v-col>
                  <v-col cols="12" md="9">
                    <v-text-field
                      v-model="organismeCe"
                      :disabled="readOnly"
                      counter="80"
                      hide-details="auto"
                      single-line
                      filled
                      dense
                      :error-messages="organismeCeErrors"
                      @input="$v.organismeCe.$touch()"
                      @blur="$v.organismeCe.$touch()"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3"
                    >Date de première mise sur le marché</v-col
                  >
                  <v-col cols="12" md="9">
                    <v-menu
                      v-model="showDpmmDate"
                      :disabled="readOnly"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dateCommercialisationAffichee"
                          :disabled="readOnly"
                          hide-details="auto"
                          filled
                          dense
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          @blur="
                            dateCommercialisation = parseDate(
                              dateCommercialisationAffichee
                            )
                          "
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateCommercialisation"
                        no-title
                        :max="new Date().toISOString()"
                        @input="showDpmmDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
            </v-expand-transition>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <h4 class="ml-5">Fabricant du DM</h4>
      </v-col>
      <v-col cols="12" md="9"
        ><v-text-field
          v-model="fabricant"
          counter="50"
          :disabled="readOnly"
          hide-details="auto"
          single-line
          filled
          dense
          :error-messages="fabricantErrors"
          @input="$v.fabricant.$touch()"
          @blur="$v.fabricant.$touch()"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <h4 class="ml-5">Statut du fournisseur</h4>
      </v-col>
      <v-col cols="12" md="9"
        ><v-select
          v-model="statutFournisseur"
          :items="['Mandataire', 'Fabricant', 'Distributeur']"
          :disabled="readOnly"
          hide-details="auto"
          single-line
          filled
          dense
          :error-messages="statutFournisseurErrors"
          @input="$v.statutFournisseur.$touch()"
          @blur="$v.statutFournisseur.$touch()"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <h4>2.6 Descriptif du dispositif</h4>
      </v-col>
      <v-col cols="12" md="9"
        ><v-textarea
          v-model="descriptif"
          :disabled="readOnly"
          hide-details="auto"
          auto-grow
          clearable
          filled
          dense
          counter="5000"
          :error-messages="descriptifErrors"
          @input="$v.descriptif.$touch()"
          @blur="$v.descriptif.$touch()"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <produit-images :readOnly="readOnly" kind="description"></produit-images>
    </v-row>

    <produit-references :readOnly="readOnly"></produit-references>
    <produit-images :readOnly="readOnly" kind="references"></produit-images>

    <produit-composition :readOnly="readOnly"></produit-composition>

    <produit-collection
      title="Substances actives"
      collection="substances"
      :isFeminin="true"
      :readOnly="readOnly"
    ></produit-collection>

    <v-row dense>
      <v-col cols="12">
        Pour les composants susceptibles d’entrer en contact avec le patient
        et/ou les produits administrés, précisions complémentaires.
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-select
          v-model="avecLatex"
          :disabled="readOnly"
          :items="optionsComposition"
          label="Latex"
          filled
          :error-messages="avecLatexErrors"
          @input="$v.avecLatex.$touch()"
          @blur="$v.avecLatex.$touch()"
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          v-model="avecPhtalates"
          :disabled="readOnly"
          :items="optionsComposition"
          label="Phtalates"
          filled
          :error-messages="avecPhtalatesErrors"
          @input="$v.avecPhtalates.$touch()"
          @blur="$v.avecPhtalates.$touch()"
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          v-model="origineAnimaleOuBiologique"
          :disabled="readOnly"
          :items="optionsComposition"
          label="Produits d'origine animale ou biologique"
          filled
          :error-messages="origineAnimaleOuBiologiqueErrors"
          @input="$v.origineAnimaleOuBiologique.$touch()"
          @blur="$v.origineAnimaleOuBiologique.$touch()"
        ></v-select>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="4">
        <v-select
          v-model="pertubateursEndocriniens"
          :disabled="readOnly"
          :items="optionsComposition"
          label="Pertubateurs endocriniens"
          filled
          :error-messages="pertubateursEndocriniensErrors"
          @input="$v.pertubateursEndocriniens.$touch()"
          @blur="$v.pertubateursEndocriniens.$touch()"
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          v-model="substancesCancerogenes"
          :disabled="readOnly"
          :items="optionsComposition"
          label="Produits cancérogènes, mutagènes et reprotoxiques (CMR)"
          filled
          :error-messages="substancesCancerogenesErrors"
          @input="$v.substancesCancerogenes.$touch()"
          @blur="$v.substancesCancerogenes.$touch()"
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          v-model="irmCompatibilite"
          :disabled="readOnly"
          :items="optionsCompositionIrm"
          label="IRM compatibilité"
          filled
          :error-messages="irmCompatibiliteErrors"
          @input="$v.irmCompatibilite.$touch()"
          @blur="$v.irmCompatibilite.$touch()"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <h4 class="ml-3">Autres composants</h4>
      </v-col>
      <v-col cols="12" md="8"
        ><v-textarea
          v-model="autresComposants"
          :disabled="readOnly"
          hide-details="auto"
          auto-grow
          clearable
          filled
          dense
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <h4 class="ml-3">
          Dispositifs et accessoires associés <br />
          (en cas de consommables captifs notamment)
        </h4>
      </v-col>
      <v-col cols="12" md="8"
        ><v-textarea
          v-model="dispositifEtAccessoiresAssocies"
          :disabled="readOnly"
          hide-details="auto"
          auto-grow
          clearable
          filled
          dense
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h4>2.9 Domaines (selon nomenclature Euro-Pharmat)</h4>
      </v-col>
    </v-row>
    <produit-collection
      :readOnly="true"
      title="Domaines"
      collection="domaines"
    ></produit-collection>
    <v-row class="mt-2">
      <v-col cols="12">
        <h4>2.10 Indications / destination</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <h4 class="ml-3">Indications (selon notice d'utilisation)</h4>
      </v-col>
      <v-col cols="12" md="8"
        ><v-textarea
          v-model="indicationsNotice"
          :disabled="readOnly"
          hide-details="auto"
          auto-grow
          clearable
          filled
          dense
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <h4 class="ml-3">Destination (selon marquage CE)</h4>
      </v-col>
      <v-col cols="12" md="8"
        ><v-textarea
          v-model="indicationsTexte"
          :disabled="readOnly"
          hide-details="auto"
          auto-grow
          clearable
          filled
          dense
        ></v-textarea>
      </v-col>
    </v-row>
    <h3>3. Procédés de stérilisation</h3>
    <v-row>
      <v-col cols="12" md="3"> <h4 class="ml-7">DM à usage unique</h4></v-col>
      <v-col cols="12" md="9" class="pb-0 mb-0">
        <v-switch
          class="mt-0"
          dense
          inset
          v-model="usageUnique"
          :disabled="readOnly"
        >
        </v-switch>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="3">
        <h4 class="ml-7">DM stérile</h4>
      </v-col>
      <v-col cols="12" md="9"
        ><v-switch
          class="mt-0 mb-0"
          dense
          inset
          hide-details
          v-model="sterile"
          :disabled="readOnly"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-card tile flat v-model="sterile" class="mt-0">
          <v-card-text>
            <v-expand-transition>
              <v-container v-show="sterile">
                <produit-collection
                  :readOnly="readOnly"
                  title="Modes de stérilisation"
                  titlePrecision=" du dispositif (Préciser les modes de stérilisation de chaque composant s'il y a lieu)"
                  collection="sterilisations"
                ></produit-collection>
              </v-container>
            </v-expand-transition>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <h3>4. Conditions de conservation</h3>
    <v-row>
      <v-col cols="12" md="3">
        <h4 class="ml-3">Conditions normales de conservation et de stockage</h4>
      </v-col>
      <v-col cols="12" md="9"
        ><v-textarea
          v-model="conditionsConservation"
          :disabled="readOnly"
          hide-details="auto"
          auto-grow
          clearable
          filled
          dense
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <h4 class="ml-3">Précautions particulières</h4>
      </v-col>
      <v-col cols="12" md="9"
        ><v-textarea
          v-model="precautions"
          :disabled="readOnly"
          hide-details="auto"
          auto-grow
          clearable
          filled
          dense
        ></v-textarea>
      </v-col>
    </v-row>

    <h3>5. Conseils d'utilisation</h3>
    <v-row>
      <v-col cols="12">
        Joindre la notice d'utilisation du produit au format PDF dans les
        documents annexés (point 6, ci-dessous)
      </v-col>
    </v-row>

    <produit-documents :readOnly="readOnly"></produit-documents>
    <produit-images :readOnly="readOnly"></produit-images>
  </v-container>
</template>

<script>
import ProduitInfoAutocomplete from "./ProduitInfoAutocomplete";
import ProduitCollection from "./ProduitCollection";
import ProduitComposition from "./ProduitComposition";
import ProduitImages from "./ProduitImages";
import ProduitDocuments from "./ProduitDocuments";
import ProduitReferences from "./ProduitReferences";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import FournisseurService from "@/services/FournisseurService";

export default {
  name: "ProduitDemandeForm",
  components: {
    ProduitInfoAutocomplete,
    ProduitCollection,
    ProduitComposition,
    ProduitImages,
    ProduitDocuments,
    ProduitReferences,
  },
  mixins: [validationMixin],
  data() {
    return {
      divisionFournisseur: null,
      idDenoCommune: null,
      denominationCommerciale: null,
      codeProduit: null,
      cladimedPro: null,
      codeLpp: null,
      classeDm: null,
      marquageCeB: false,
      marquageCe: null,
      organismeCe: null,
      dateCommercialisation: null,
      dateCommercialisationAffichee: null,
      fabricant: null,
      statutFournisseur: null,
      descriptif: null,
      avecLatex: null,
      avecPhtalates: null,
      origineAnimaleOuBiologique: null,
      pertubateursEndocriniens: null,
      substancesCancerogenes: null,
      irmCompatibilite: null,
      autresComposants: null,
      dispositifEtAccessoiresAssocies: null,
      indicationsNotice: null,
      indicationsTexte: null,
      sterile: false,
      usageUnique: false,
      conditionsConservation: null,
      precautions: null,
      // les suivants sont à élminier du processus de recomposiiton du produit pour envoi demande dans DemandeMain.vue
      searchDeno: "",
      itemsDeno: [],
      showDpmmDate: false,
      optionsComposition: ["Non", "Oui"],
    };
  },
  computed: {
    produit() {
      return this.$store.state.demandeEditee.produit;
    },
    demande() {
      return this.$store.state.demandeEditee.demande;
    },
    fournisseur() {
      return this.$store.state.identite.fournisseur;
    },
    readOnly() {
      return (
        this.demande &&
        typeof this.demande.etat != "undefined" &&
        (this.demande.etat == 2 || this.demande.etat == 4)
      );
    },
    optionsCompositionIrm() {
      let options = this.optionsComposition.slice();
      options.splice(1, 0, "Sous condition - cf Notice");
      return options;
    },
    idDenoCommuneErrors() {
      const errors = [];
      if (!this.$v.idDenoCommune.$dirty) return errors;
      !this.$v.idDenoCommune.required && errors.push("Obligatoire");
      !this.$v.idDenoCommune.minLength && errors.push("Obligatoire");
      return errors;
    },
    denominationCommercialeErrors() {
      const errors = [];
      if (!this.$v.denominationCommerciale.$dirty) return errors;
      !this.$v.denominationCommerciale.required && errors.push("Obligatoire");
      !this.$v.denominationCommerciale.minLength &&
        errors.push("2 caractères au minimum");
      !this.$v.denominationCommerciale.maxLength &&
        errors.push("500 caractères au maximum");
      return errors;
    },
    descriptifErrors() {
      const errors = [];
      if (!this.$v.descriptif.$dirty) return errors;
      !this.$v.descriptif.required && errors.push("Obligatoire");
      !this.$v.descriptif.maxLength && errors.push("Limité à 5000 caractères");
      return errors;
    },
    cladimedProErrors() {
      const errors = [];
      if (!this.$v.cladimedPro.$dirty) return errors;
      !this.$v.cladimedPro.maxLength && errors.push("Limité à 50 caractères");
      return errors;
    },
    classeDmErrors() {
      const errors = [];
      if (!this.$v.classeDm.$dirty) return errors;
      !this.$v.classeDm.maxLength && errors.push("Limité à 20 caractères");
      return errors;
    },
    codeLppErrors() {
      const errors = [];
      if (!this.$v.codeLpp.$dirty) return errors;
      !this.$v.codeLpp.maxLength && errors.push("Limité à 80 caractères");
      return errors;
    },
    statutFournisseurErrors() {
      const errors = [];
      if (!this.$v.statutFournisseur.$dirty) return errors;
      !this.$v.statutFournisseur.required && errors.push("Obligatoire");
      return errors;
    },
    divisionFournisseurErrors() {
      const errors = [];
      if (!this.$v.divisionFournisseur.$dirty) return errors;
      !this.$v.divisionFournisseur.maxLength &&
        errors.push("Limité à 80 caractères");
      return errors;
    },
    marquageCeErrors() {
      const errors = [];
      if (!this.$v.marquageCe.$dirty) return errors;
      !this.$v.marquageCe.maxLength && errors.push("Limité à 120 caractères");
      return errors;
    },
    organismeCeErrors() {
      const errors = [];
      if (!this.$v.organismeCe.$dirty) return errors;
      !this.$v.organismeCe.maxLength && errors.push("Limité à 80 caractères");
      return errors;
    },
    codeProduitErrors() {
      const errors = [];
      if (!this.$v.codeProduit.$dirty) return errors;
      !this.$v.codeProduit.maxLength && errors.push("Limité à 50 caractères");
      return errors;
    },
    fabricantErrors() {
      const errors = [];
      if (!this.$v.fabricant.$dirty) return errors;
      !this.$v.fabricant.maxLength && errors.push("Limité à 50 caractères");
      return errors;
    },
    avecLatexErrors() {
      const errors = [];
      if (!this.$v.avecLatex.$dirty) return errors;
      !this.$v.avecLatex.required && errors.push("Obligatoire");
      return errors;
    },
    avecPhtalatesErrors() {
      const errors = [];
      if (!this.$v.avecPhtalates.$dirty) return errors;
      !this.$v.avecPhtalates.required && errors.push("Obligatoire");
      return errors;
    },
    origineAnimaleOuBiologiqueErrors() {
      const errors = [];
      if (!this.$v.origineAnimaleOuBiologique.$dirty) return errors;
      !this.$v.origineAnimaleOuBiologique.required &&
        errors.push("Obligatoire");
      return errors;
    },
    pertubateursEndocriniensErrors() {
      const errors = [];
      if (!this.$v.pertubateursEndocriniens.$dirty) return errors;
      !this.$v.pertubateursEndocriniens.required && errors.push("Obligatoire");
      return errors;
    },
    substancesCancerogenesErrors() {
      const errors = [];
      if (!this.$v.substancesCancerogenes.$dirty) return errors;
      !this.$v.substancesCancerogenes.required && errors.push("Obligatoire");
      return errors;
    },
    irmCompatibiliteErrors() {
      const errors = [];
      if (!this.$v.irmCompatibilite.$dirty) return errors;
      !this.$v.irmCompatibilite.required && errors.push("Obligatoire");
      return errors;
    },
  },
  watch: {
    dateCommercialisation() {
      this.dateCommercialisationAffichee = this.formatDate(
        this.dateCommercialisation
      );
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    denoCommuneInput(idDC) {
      this.$v.idDenoCommune.$touch();
      //console.log("test change DC " + idDC);
      // Obtention des domaines de la nouvelle DC
      FournisseurService.getDomainesDeno(idDC)
        .then((res) =>
          this.$store.dispatch(
            "demandeEditee/setDomainesProduitEdite",
            res.data
          )
        )
        .catch((err) => {
          this.$store.dispatch(
            "setErreur",
            new Error(
              "L'obtention des domaines liés à la dénomination commune sur le serveur a échoué. Veuillez réessayer. Dans l'hypothèse où cette erreur se reproduirait, merci de contacter l'équipe d'Euro-Pharmat, et de lui transmettre le code erreur suivant: " +
                err
            )
          );
        });
    },
  },
  mounted() {
    for (let prop in this.produit) {
      try {
        if (prop == "dateCommercialisation") {
          this[prop] = this.produit[prop].substring(0, 10);
          this.dateCommercialisationAffichee = this.formatDate(
            this.dateCommercialisation
          );
        } else {
          this[prop] = this.produit[prop];
        }
      } catch (ex) {
        console.log(ex);
      }
    }
    this.$v.$touch();
  },
  validations: {
    idDenoCommune: {
      required,
      minLength: minLength(1),
    },
    divisionFournisseur: {
      maxLength: maxLength(80),
    },
    denominationCommerciale: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(500),
    },
    descriptif: {
      required,
      maxLength: maxLength(5000),
    },
    fabricant: {
      maxLength: maxLength(50),
    },
    marquageCe: {
      maxLength: maxLength(120),
    },
    organismeCe: {
      maxLength: maxLength(80),
    },
    cladimedPro: {
      maxLength: maxLength(50),
    },
    codeProduit: {
      maxLength: maxLength(50),
    },
    classeDm: {
      maxLength: maxLength(20),
    },
    codeLpp: {
      maxLength: maxLength(80),
    },
    statutFournisseur: {
      required,
    },
    avecLatex: {
      required,
    },
    avecPhtalates: {
      required,
    },
    origineAnimaleOuBiologique: {
      required,
    },
    pertubateursEndocriniens: {
      required,
    },
    substancesCancerogenes: {
      required,
    },
    irmCompatibilite: {
      required,
    },
    // informationsComplementaires: {
    //   maxLength: maxLength(80),
    // },
  },
};
</script>

<style lang="scss">
.hint {
  margin-top: -1.25em;
  color: #fa3;
  font-style: italic;
  font-size: 0.8em;
}

// Reversed input variant
.v-input--reverse .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;
  .v-application--is-ltr & {
    .v-input--selection-controls__input {
      margin-right: 0;
      margin-left: 1em;
    }
  }
  .v-application--is-rtl & {
    .v-input--selection-controls__input {
      margin-left: 0;
      margin-right: 1em;
    }
  }
  .v-label:only-of-type {
    flex: none;
  }
}

// Bonus "expand" variant
.v-input--expand .v-input__slot {
  // justify-content: space-between;
  .v-label {
    display: block;
    flex: 1;
  }
}
</style>
